import React from "react";
import { string, shape, object, array, oneOfType, arrayOf, bool, func, oneOf } from "prop-types";
import classNames from "classnames/bind";
import { MediaGalleryModal as MediaGalleryComponent } from "../../sharedComponents/MediaGallery";
import "./ThumbSlider.scss";
import * as modalStyles from "../Modal/Modal.module.scss";
import * as styles from "./MediaGallery.module.scss";
import { Icon } from "../Icons";
import { RCL } from "../RCL";

const cx = classNames.bind(styles);
const cxModal = classNames.bind(modalStyles);

const MediaGalleryModal = ({
	gallery,
	video,
	map,
	lang,
	isOpen,
	setIsOpen,
	isVideoOpen,
	isMapOpen,
}) => (
	<MediaGalleryComponent
		className={cx("mediaGallery")}
		gallery={gallery}
		a11y={{
			prevSlideLabel: "prevSlideLabel",
			nextSlideLabel: "nextSlideLabel",
			firstSlideLabel: "firstSlideLabel",
			lastSlideLabel: "lastSlideLabel",
			paginationBulletLabel: "paginationBulletLabel {{index}}",
			stopSliderLabel: "stopSliderLabel",
			startSliderLabel: "startSliderLabel",
		}}
		isOpen={isOpen}
		setIsOpen={setIsOpen}
		isModal={true}
		video={video}
		isVideoOpen={isVideoOpen}
		isMapOpen={isMapOpen}
		map={map}
		pagination={
			(swiper, current, total) =>
				lang === "en"
					? `<span class="${cx("pagination")}">${current} of ${total} <span>photos</span></span>`
					: `<span class="${cx("pagination")}"><span>Photos</span> ${current} sur ${total}</span>`
			// eslint-disable-next-line react/jsx-curly-newline
		}
		mapButton={
			<>
				<Icon name="map" />
				<RCL searchKey="map" />
			</>
		}
		closeButton={<Icon name="close--n" className="swg-text-3xl" />}
		modalClasses={{
			content: cx("modalContent"),
			modal: cx("modal"),
			wrapper: cx("modalContentWrapper"),
			overlay: cxModal("overlay"),
			close: cxModal("close"),
		}}
		videoButton={
			// TODO:: RCL
			<>
				<Icon name="video" />
				<RCL searchKey="video" />
			</>
		}
		footerClasses={{
			nav: cx("nav"),
			wrapper: cx("wrapper"),
			thumbs: cx("thumbs"),
			miscContainer: cx("miscContainer"),
			miscButtons: cx("misc"),
		}}
		sliderClasses={{
			main: {
				slide: cx("mainSlide"),
				slider: cx("mainSlider"),
				navigation: {
					button: cx("mainNavigationButton"),
					nextButton: cx("mainNavigationNextButton"),
					prevButton: cx("mainNavigationPrevButton"),
				},
			},
			thumb: {
				slide: cx("thumbSlide"),
				navigation: {
					button: cx("thumbNavigationButton"),
					nextButton: cx("thumbNavigationNextButton"),
					prevButton: cx("thumbNavigationPrevButton"),
				},
			},
		}}
	/>
);

MediaGalleryModal.propTypes = {
	gallery: arrayOf(
		shape({
			fluid: oneOfType([object, array]),
			fixed: oneOfType([object, array]),
			source: shape({
				src: string,
				srcSet: string,
				sizes: string,
			}),
			alt: string,
			src: string,
		})
	).isRequired,
	lang: oneOf(["en", "fr"]),
	video: shape({
		videoId: string,
		playlistId: string,
	}),
	map: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}),
	isOpen: bool.isRequired,
	setIsOpen: func.isRequired,
	isVideoOpen: bool,
	isMapOpen: bool,
};
MediaGalleryModal.defaultProps = {
	lang: "en",
	video: null,
	map: null,
	isVideoOpen: false,
	isMapOpen: false,
};
export default MediaGalleryModal;
export { MediaGalleryModal };
